import { render } from "./Header.vue?vue&type=template&id=7f8f1e8c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=7f8f1e8c&scoped=true&lang=scss"

import exportComponent from "/Users/pepijnvdk/TNT/wewantyou/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8f1e8c"]])

export default __exports__